import type { ReactNode } from "react";
import { cx } from "@/lib/cx";

interface PillProps {
  variant?: "brand" | "muted" | "success" | "warn";
  className?: string;
  children: ReactNode;
}

const VARIANT_CLASS: Record<NonNullable<PillProps["variant"]>, string | undefined> = {
  brand: undefined, // base .pill is brand-coloured
  muted: "pill-muted",
  success: "pill-success",
  warn: "pill-warn",
};

export default function Pill({ variant = "brand", className, children }: PillProps): JSX.Element {
  return <span className={cx("pill", VARIANT_CLASS[variant], className)}>{children}</span>;
}
